/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OAuthAppSecretRotationStatusEnum = 'NON_ROTATABLE' | 'ROTATION_ENABLED' | 'ROTATION_DISABLED' | 'ROTATION_OVERDUE' | 'UNKNOWN';

export const OAuthAppSecretRotationStatusEnum = {

    NON_ROTATABLE: 'NON_ROTATABLE' as OAuthAppSecretRotationStatusEnum,

    ROTATION_ENABLED: 'ROTATION_ENABLED' as OAuthAppSecretRotationStatusEnum,

    ROTATION_DISABLED: 'ROTATION_DISABLED' as OAuthAppSecretRotationStatusEnum,

    ROTATION_OVERDUE: 'ROTATION_OVERDUE' as OAuthAppSecretRotationStatusEnum,

    UNKNOWN: 'UNKNOWN' as OAuthAppSecretRotationStatusEnum
};

